// extracted by mini-css-extract-plugin
export var cardHeader = "_qx-0";
export var reorderHandle = "_qx-3";
export var titleArea = "_qx-1";
export var titleAreaWithHandle = "_qx-2";